module.exports = __webpack_public_path__ + "static/TheMetSans-BoldItalic-4f419bc7f86100b4e313e47515afcdcc.woff2";